export const getEmailComponentsList = () =>
  [
    { folder: 'common', label: 'Body', name: 'Body' },
    { folder: 'single', label: 'Button', name: 'Button' },
    { folder: 'common', label: 'Column', name: 'Column' },
    { folder: 'single', label: 'Divider', name: 'Divider' },
    {
      folder: 'common',
      name: 'EmptyDocumentPlaceholder',
      label: 'EmptyDocumentPlaceholder',
    },
    { folder: 'block', label: 'Hero', name: 'Hero' },
    { folder: 'single', label: 'Html', name: 'Html' },
    { folder: 'single', label: 'EmailImage', name: 'EmailImage' },
    {
      folder: 'block',
      label: 'EmailActivationButton',
      name: 'EmailActivationButton',
    },
    {
      folder: 'block',
      label: 'EmailMirrorLink',
      name: 'EmailMirrorLink',
    },
    { folder: 'block', label: 'EmailFooter', name: 'EmailFooter' },
    { folder: 'common', label: 'Root', name: 'Root' },
    { folder: 'common', label: 'Section', name: 'Section' },
    { folder: 'single', label: 'Spacer', name: 'Spacer' },
    { folder: 'single', label: 'Text', name: 'Text' },
    { folder: 'dynamic', label: 'EmailList', name: 'EmailList' },
    {
      folder: 'dynamic',
      label: 'EmailPublication',
      name: 'EmailPublication',
    },

    // Empty Structures
    { folder: 'structure/empty', label: 'HalfWidth', name: 'HalfWidth' },
    { folder: 'structure/empty', label: 'FullWidth', name: 'FullWidth' },
    { folder: 'structure/empty', label: 'OneTwoThird', name: 'OneTwoThird' },
    { folder: 'structure/empty', label: 'TwoOneThird', name: 'TwoOneThird' },
    { folder: 'structure/empty', label: 'ThreeColumns', name: 'ThreeColumns' },
    { folder: 'structure/empty', label: 'FourColumns', name: 'FourColumns' },

    // Predefined Structures
    {
      folder: 'structure/predefined',
      label: 'TwoColumnsAltImageText',
      name: 'TwoColumnsAltImageText',
    },
    {
      folder: 'structure/predefined',
      label: 'TwoColumnsImages',
      name: 'TwoColumnsImages',
    },
    {
      folder: 'structure/predefined',
      label: 'TwoColumnsImageText',
      name: 'TwoColumnsImageText',
    },
    {
      folder: 'structure/predefined',
      label: 'ThreeColumnsImageText',
      name: 'ThreeColumnsImageText',
    },
    {
      folder: 'structure/predefined',
      label: 'FourColumnsAltImageText',
      name: 'FourColumnsAltImageText',
    },
    {
      folder: 'structure/predefined',
      label: 'FourColumnsImageText',
      name: 'FourColumnsImageText',
    },
  ].filter(Boolean);
